(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstone-index"] && !Shopify.designMode) return;
  try {
    
  const getStoneGroup = (name) => {
    const initial = Array.from(name.trim())[0] || '';
    if ('アイウエオァィゥェォヴ'.includes(initial)) return 'a';
    if ('カキクケコガギグゲゴヵヶ'.includes(initial)) return 'ka';
    if ('サシスセソザジズゼゾ'.includes(initial)) return 'sa';
    if ('タチツテトダヂヅデドッ'.includes(initial)) return 'ta';
    if ('ナニヌネノ'.includes(initial)) return 'na';
    if ('ハヒフヘホバビブベボパピプペポ'.includes(initial)) return 'ha';
    if ('マミムメモ'.includes(initial)) return 'ma';
    if ('ヤユヨャュョ'.includes(initial)) return 'ya';
    if ('ラリルレロ'.includes(initial)) return 'ra';
    return 'other';
  };

  const createStoneCard = (stone, countSuffix) => {
    const card = document.createElement('a');
    card.className = 'gemstone-index__card';
    card.href = stone.url;

    const media = document.createElement('span');
    media.className = 'gemstone-index__media';
    if (stone.image) {
      const image = document.createElement('img');
      image.className = 'gemstone-index__image';
      image.src = stone.image;
      image.alt = stone.name;
      image.loading = 'lazy';
      image.width = 240;
      image.height = 240;
      media.append(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'gemstone-index__placeholder';
      placeholder.textContent = Array.from(stone.name)[0] || '石';
      media.append(placeholder);
    }

    const text = document.createElement('span');
    const name = document.createElement('span');
    name.className = 'gemstone-index__name';
    name.textContent = stone.name;
    const count = document.createElement('span');
    count.className = 'gemstone-index__count';
    count.textContent = `${stone.count}${countSuffix}`;
    text.append(name, count);
    card.append(media, text);
    return card;
  };

  const priceBands = [
    { value: 'under-1500', label: '1,499円以下', matches: (price) => price < 1500 },
    { value: '1500-1999', label: '1,500〜1,999円', matches: (price) => price >= 1500 && price < 2000 },
    { value: '2000-2499', label: '2,000〜2,499円', matches: (price) => price >= 2000 && price < 2500 },
    { value: 'over-2500', label: '2,500円以上', matches: (price) => price >= 2500 },
  ];

  const createFilterOption = (type, value, label, count) => {
    const option = document.createElement('label');
    option.className = 'gemstone-filter__option';
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.value = value;
    input.dataset.filterType = type;
    const text = document.createElement('span');
    text.textContent = label;
    const optionCount = document.createElement('span');
    optionCount.className = 'gemstone-filter__option-count';
    optionCount.textContent = `(${count})`;
    option.append(input, text, optionCount);
    return option;
  };

  const createFilterResultCard = (product, priceFormatter) => {
    const card = document.createElement('a');
    card.className = 'gemstone-filter-result';
    card.href = product.url;
    if (product.image) {
      const media = document.createElement('span');
      media.className = 'gemstone-filter-result__media';
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 480;
      image.height = 480;
      media.append(image);
      card.append(media);
    }
    const title = document.createElement('p');
    title.className = 'gemstone-filter-result__title';
    title.textContent = product.title;
    const meta = document.createElement('p');
    meta.className = 'gemstone-filter-result__meta';
    meta.textContent = [product.stone, product.shape, product.cut].filter(Boolean).join('・');
    const price = document.createElement('p');
    price.className = 'gemstone-filter-result__price';
    price.textContent = priceFormatter.format(product.price);
    card.append(title);
    if (meta.textContent) card.append(meta);
    card.append(price);
    return card;
  };

  const initProductFilter = (root, products) => {
    const filter = root.querySelector('[data-gemstone-filter]');
    if (!filter) return;
    filter.hidden = products.length === 0;
    if (!products.length) return;

    const valueCounts = (getter) => {
      const counts = new Map();
      products.forEach((product) => {
        const values = getter(product);
        const uniqueValues = new Set(Array.isArray(values) ? values : [values]);
        uniqueValues.forEach((value) => {
          if (value) counts.set(value, (counts.get(value) || 0) + 1);
        });
      });
      return [...counts.entries()].sort((left, right) => left[0].localeCompare(right[0], 'ja'));
    };

    const optionGroups = {
      stone: valueCounts((product) => product.stone),
      shape: valueCounts((product) => product.shape),
      cut: valueCounts((product) => product.cut),
      color: valueCounts((product) => product.colors),
    };

    Object.entries(optionGroups).forEach(([type, options]) => {
      const container = root.querySelector(`[data-filter-options="${type}"]`);
      options.forEach(([value, count]) => container?.append(createFilterOption(type, value, value, count)));
    });

    const priceOptions = root.querySelector('[data-filter-options="price"]');
    priceBands.forEach((band) => {
      const count = products.filter((product) => band.matches(product.price)).length;
      if (count) priceOptions?.append(createFilterOption('price', band.value, band.label, count));
    });

    const tabs = root.querySelectorAll('[data-filter-tab]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        root.querySelectorAll('[data-filter-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.filterPanel !== tab.dataset.filterTab;
        });
      });
    });

    const selectedValues = (type) => new Set(
      [...root.querySelectorAll(`[data-filter-options="${type}"] input:checked`)].map((input) => input.value),
    );

    const filteredProducts = () => {
      const selected = {
        stone: selectedValues('stone'),
        shape: selectedValues('shape'),
        cut: selectedValues('cut'),
        color: selectedValues('color'),
        price: selectedValues('price'),
      };
      return products.filter((product) => {
        const stoneMatch = !selected.stone.size || selected.stone.has(product.stone);
        const shapeMatch = !selected.shape.size || selected.shape.has(product.shape);
        const cutMatch = !selected.cut.size || selected.cut.has(product.cut);
        const colorMatch = !selected.color.size || product.colors.some((color) => selected.color.has(color));
        const priceMatch = !selected.price.size || priceBands.some((band) => selected.price.has(band.value) && band.matches(product.price));
        return stoneMatch && shapeMatch && cutMatch && colorMatch && priceMatch;
      });
    };

    const count = root.querySelector('[data-filter-count]');
    const updateCount = () => {
      if (count) count.textContent = filteredProducts().length;
    };
    root.querySelectorAll('[data-filter-options] input').forEach((input) => input.addEventListener('change', updateCount));
    updateCount();

    const results = root.querySelector('[data-filter-results]');
    const resultsGrid = root.querySelector('[data-filter-results-grid]');
    const resultsCount = root.querySelector('[data-filter-results-count]');
    const resultsEmpty = root.querySelector('[data-filter-results-empty]');
    const priceFormatter = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
    const renderResults = () => {
      const matches = filteredProducts();
      if (resultsGrid) resultsGrid.replaceChildren(...matches.map((product) => createFilterResultCard(product, priceFormatter)));
      if (resultsCount) resultsCount.textContent = matches.length;
      if (resultsEmpty) resultsEmpty.hidden = matches.length > 0;
      if (results) results.hidden = false;
    };

    root.querySelector('[data-filter-apply]')?.addEventListener('click', () => {
      if (document.startViewTransition) {
        document.startViewTransition(renderResults);
      } else {
        renderResults();
      }
      results?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.querySelector('[data-filter-clear]')?.addEventListener('click', () => {
      root.querySelectorAll('[data-filter-options] input').forEach((input) => {
        input.checked = false;
      });
      updateCount();
      if (results) results.hidden = true;
    });
  };

  const initGemstoneIndex = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const sources = [...root.querySelectorAll('[data-stone-source]')];
    const products = sources.map((source) => ({
      title: source.dataset.productTitle || '',
      url: source.dataset.productUrl || '#',
      image: source.dataset.image || '',
      stone: source.dataset.name?.trim() || '',
      shape: source.dataset.shape?.trim() || '',
      cut: source.dataset.cut?.trim() || '',
      colors: (source.dataset.colors || '').split('||').filter(Boolean),
      price: Number(source.dataset.price || 0) / 100,
    }));
    initProductFilter(root, products);

    const stones = new Map();
    sources.forEach((source) => {
      const name = source.dataset.name?.trim();
      if (!name) return;
      const existing = stones.get(name);
      if (existing) {
        existing.count += 1;
      } else {
        stones.set(name, {
          name,
          url: source.dataset.url || '#',
          image: source.dataset.image || '',
          count: 1,
        });
      }
    });

    const sortedStones = Array.from(stones.values()).sort((left, right) => left.name.localeCompare(right.name, 'ja'));
    const countSuffix = root.dataset.countSuffix || '商品';
    const popular = root.querySelector('[data-popular-stones]');
    const popularStones = [...sortedStones].sort((left, right) => right.count - left.count || left.name.localeCompare(right.name, 'ja')).slice(0, 8);
    popularStones.forEach((stone) => popular?.append(createStoneCard(stone, countSuffix)));

    sortedStones.forEach((stone) => {
      root.querySelector(`[data-stone-group="${getStoneGroup(stone.name)}"]`)?.append(createStoneCard(stone, countSuffix));
    });

    root.querySelectorAll('[data-stone-group-section]').forEach((section) => {
      section.hidden = !section.querySelector('.gemstone-index__card');
    });

    const isEmpty = sortedStones.length === 0;
    const empty = root.querySelector('[data-stone-empty]');
    if (empty) empty.hidden = !isEmpty;
    const popularSection = root.querySelector('[data-popular-section]');
    if (popularSection) popularSection.hidden = isEmpty;
    root.querySelector('[data-stone-source-list]')?.remove();
  };

  const initAllGemstoneIndexes = () => {
    document.querySelectorAll('[data-gemstone-index]').forEach(initGemstoneIndex);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGemstoneIndexes, { once: true });
  } else {
    initAllGemstoneIndexes();
  }
  document.addEventListener('shopify:section:load', initAllGemstoneIndexes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenken-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-kenken-hero]');
    if (!hero || hero.dataset.initialized === 'true') return;
    hero.dataset.initialized = 'true';

    const rail = hero.querySelector('[data-hero-rail]');
    const previous = hero.querySelector('[data-hero-previous]');
    const next = hero.querySelector('[data-hero-next]');

    const updateButtons = () => {
      previous.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };

    const move = (direction) => {
      rail.scrollBy({ left: rail.clientWidth * 0.72 * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenken-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-kenken-product-rail]').forEach((section) => {
    const track = section.querySelector('[data-kenken-product-track]');
    const previous = section.querySelector('[data-kenken-product-prev]');
    const next = section.querySelector('[data-kenken-product-next]');
    if (!track || !previous || !next) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 320), behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-commerce-enhancements"] && !Shopify.designMode) return;
  try {
    
  const initProductEnhancements = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const mainProduct = document.querySelector('.product');
    const mediaWrapper = mainProduct?.querySelector('.product__media-wrapper');
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    const originalAdd = productInfo?.querySelector('button[name="add"]');
    const originalQuantity = productInfo?.querySelector('input[name="quantity"]');
    const originalPrice = productInfo?.querySelector('[id^="price-"]');
    const buttons = productInfo?.querySelector('.product-form__buttons');
    const template = root.querySelector('[data-purchase-option-template]');
    const stickyCart = root.querySelector('[data-sticky-cart]');
    const stickyOption = root.querySelector('[data-sticky-purchase-option]');
    const stickyQuantity = root.querySelector('[data-sticky-quantity]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const stickyPrice = root.querySelector('[data-sticky-price]');

    if (mediaWrapper) {
      const mediaGallery = mediaWrapper.querySelector('media-gallery');
      mediaGallery?.classList.remove('product__column-sticky');

      let panelsContainer = mediaWrapper.querySelector('[data-kenken-product-panels]');
      if (!panelsContainer) {
        panelsContainer = document.createElement('div');
        panelsContainer.className = 'kenken-product-panels';
        panelsContainer.dataset.kenkenProductPanels = '';
        if (mediaGallery) {
          mediaGallery.insertAdjacentElement('afterend', panelsContainer);
        } else {
          mediaWrapper.append(panelsContainer);
        }
      }

      const movePanel = (element) => {
        if (!element) return;
        const panel = element.closest('.shopify-section') || element;
        panel.classList.add('kenken-product-panel');
        panelsContainer.append(panel);
      };

      movePanel(document.querySelector('.product-description-panel'));
      movePanel(document.querySelector('.gem-specifications-section'));
      movePanel(root);
      movePanel(document.querySelector('.purchase-guidance'));

      const mediaList = mainProduct.querySelector('.product__media-list');
      if (mediaList) {
        const videoItems = Array.from(mediaList.children).filter((item) => {
          const templateContent = item.querySelector('template')?.innerHTML || '';
          return item.querySelector('video') || templateContent.includes('<video') || templateContent.includes('youtube') || templateContent.includes('vimeo');
        });
        videoItems.forEach((item) => {
          item.classList.add('kenken-video-media');
          mediaList.append(item);
        });

        if (videoItems.length > 0 && mediaGallery) {
          let mobileVideoStack = mediaWrapper.querySelector('[data-kenken-mobile-videos]');
          if (!mobileVideoStack) {
            mobileVideoStack = document.createElement('ul');
            mobileVideoStack.className = 'kenken-mobile-video-stack';
            mobileVideoStack.dataset.kenkenMobileVideos = '';
            mediaGallery.insertAdjacentElement('afterend', mobileVideoStack);
          }

          const mobileMedia = window.matchMedia('(max-width: 749px)');
          const syncVideoPosition = () => {
            videoItems.forEach((item) => {
              const mediaTarget = item.id.replace(/^Slide-/, '');
              const thumbnail = mediaGallery.querySelector(`[data-target="${mediaTarget}"]`);
              if (mobileMedia.matches) {
                mobileVideoStack.append(item);
                if (thumbnail) thumbnail.hidden = true;
              } else {
                mediaList.append(item);
                if (thumbnail) thumbnail.hidden = false;
              }
            });
          };

          syncVideoPosition();
          mobileMedia.addEventListener('change', syncVideoPosition);
        }
      }
    }

    if (buttons && template && !buttons.querySelector('[data-purchase-option]')) {
      buttons.prepend(template.content.cloneNode(true));
    }

    const inlineOption = buttons?.querySelector('[data-purchase-option]');

    const setQuantity = (value) => {
      const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      if (originalQuantity) {
        originalQuantity.value = quantity;
        originalQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (stickyQuantity) stickyQuantity.value = quantity;
      if (inlineOption && quantity <= 3) inlineOption.value = String(quantity);
      if (stickyOption && quantity <= 3) stickyOption.value = String(quantity);
    };

    inlineOption?.addEventListener('change', (event) => setQuantity(event.target.value));
    stickyOption?.addEventListener('change', (event) => setQuantity(event.target.value));
    stickyQuantity?.addEventListener('change', (event) => setQuantity(event.target.value));
    originalQuantity?.addEventListener('change', (event) => setQuantity(event.target.value));

    stickyAdd?.addEventListener('click', () => {
      setQuantity(stickyQuantity?.value || 1);
      originalAdd?.click();
    });

    if (originalAdd && stickyCart) {
      const cartObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const passedOriginalButton = entry.boundingClientRect.top < 0;
        const visible = !entry.isIntersecting && passedOriginalButton;
        stickyCart.classList.toggle('is-visible', visible);
        stickyCart.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('kenken-sticky-cart-visible', visible);
      }, { threshold: 0 });
      cartObserver.observe(originalAdd);
    }

    if (originalPrice && stickyPrice) {
      const syncPrice = () => {
        const priceText = originalPrice.textContent.trim();
        if (priceText) stickyPrice.textContent = priceText;
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(originalPrice, { childList: true, subtree: true, characterData: true });
    }

    const observeVideo = (video) => {
      if (video.dataset.autoplayReady === 'true') return;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.35 });
      videoObserver.observe(video);
    };

    mainProduct?.querySelectorAll('deferred-media').forEach((media) => {
      const templateContent = media.querySelector('template')?.innerHTML || '';
      if (templateContent.includes('<video')) {
        const loadVideo = () => media.querySelector('button')?.click();
        const mobileVideo = window.matchMedia('(max-width: 749px)').matches && media.closest('[data-kenken-mobile-videos]');
        if (mobileVideo) {
          const loadObserver = new IntersectionObserver((entries, observer) => {
            if (entries[0].isIntersecting) {
              loadVideo();
              observer.disconnect();
            }
          }, { threshold: 0.1 });
          loadObserver.observe(media);
        } else {
          loadVideo();
        }
      }
    });

    mainProduct?.querySelectorAll('video').forEach(observeVideo);
    if (mainProduct) {
      new MutationObserver(() => {
        mainProduct.querySelectorAll('video').forEach(observeVideo);
      }).observe(mainProduct, { childList: true, subtree: true });
    }
  };

  const initAllProductEnhancements = () => {
    document.querySelectorAll('[data-product-enhancements]').forEach(initProductEnhancements);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductEnhancements, { once: true });
  } else {
    initAllProductEnhancements();
  }

  document.addEventListener('shopify:section:load', initAllProductEnhancements);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-color"] && !Shopify.designMode) return;
  try {
    
  const colorPalette = [
    { name: 'クリア', color: '#f3f3f3' },
    { name: 'ホワイト', color: '#ffffff' },
    { name: 'グレー', color: '#9a9a9a' },
    { name: 'ブラック', color: '#171717' },
    { name: 'レッド', color: '#d94b43' },
    { name: 'ピンク', color: '#e96bb6' },
    { name: 'オレンジ', color: '#ec9633' },
    { name: 'イエロー', color: '#f1d85a' },
    { name: 'パープル', color: '#8662b8' },
    { name: 'ブルー', color: '#4e8fd8' },
    { name: 'グリーン', color: '#4ea86f' },
    { name: 'ブラウン', color: '#8a5d2b' },
    { name: 'ベージュ', color: '#d9c38c' },
    { name: 'ゴールド', color: '#c99b28' },
    { name: 'シルバー', color: '#b9bec4' },
    { name: 'パステル', color: '#c9ddcf' },
    { name: 'ミックス', color: '#baa8da' },
    { name: 'マルチカラー', color: '#b6cce0' },
  ];

  const colorConfig = (name) => colorPalette.find((entry) => entry.name === name) || { name, color: '#d8d8d8' };

  const colorAnchor = (name) => `Color-${encodeURIComponent(name).replaceAll('%', '')}`;

  const createColorSwatch = (group) => {
    const config = colorConfig(group.name);
    const link = document.createElement('a');
    link.className = 'color-explorer__swatch-link';
    link.href = `#${colorAnchor(group.name)}`;
    link.style.setProperty('--swatch-color', config.color);
    const swatch = document.createElement('span');
    swatch.className = 'color-explorer__swatch';
    swatch.setAttribute('aria-hidden', 'true');
    const name = document.createElement('span');
    name.className = 'color-explorer__swatch-name';
    name.textContent = group.name;
    const count = document.createElement('span');
    count.className = 'color-explorer__swatch-count';
    count.textContent = `${group.products.length}商品`;
    link.append(swatch, name, count);
    return link;
  };

  const createColorProduct = (product, formatter) => {
    const card = document.createElement('a');
    card.className = 'color-explorer__product';
    card.href = product.url;
    if (product.image) {
      const media = document.createElement('span');
      media.className = 'color-explorer__product-media';
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 480;
      image.height = 480;
      media.append(image);
      card.append(media);
    }
    const title = document.createElement('p');
    title.className = 'color-explorer__product-title';
    title.textContent = product.title;
    const price = document.createElement('p');
    price.className = 'color-explorer__product-price';
    price.textContent = formatter.format(product.price);
    card.append(title, price);
    return card;
  };

  const createColorGroup = (group, formatter) => {
    const config = colorConfig(group.name);
    const section = document.createElement('section');
    section.className = 'color-explorer__group';
    section.id = colorAnchor(group.name);
    section.style.setProperty('--swatch-color', config.color);
    const heading = document.createElement('div');
    heading.className = 'color-explorer__group-heading';
    const title = document.createElement('h2');
    title.textContent = `${group.name}の代表的な天然石`;
    const back = document.createElement('a');
    back.className = 'color-explorer__back';
    back.href = '#MainContent';
    back.textContent = '色一覧へ戻る';
    heading.append(title, back);
    const stones = document.createElement('ul');
    stones.className = 'color-explorer__stones';
    [...new Set(group.products.map((product) => product.stone).filter(Boolean))].sort((left, right) => left.localeCompare(right, 'ja')).forEach((stoneName) => {
      const item = document.createElement('li');
      item.className = 'color-explorer__stone';
      item.textContent = stoneName;
      stones.append(item);
    });
    const products = document.createElement('div');
    products.className = 'color-explorer__products';
    group.products.forEach((product) => products.append(createColorProduct(product, formatter)));
    section.append(heading);
    if (stones.children.length) section.append(stones);
    section.append(products);
    return section;
  };

  const initColorExplorer = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const products = [...root.querySelectorAll('[data-color-source]')].map((source) => ({
      title: source.dataset.title || '',
      url: source.dataset.url || '#',
      image: source.dataset.image || '',
      stone: source.dataset.stone || '',
      colors: (source.dataset.colors || '').split('||').filter(Boolean),
      price: Number(source.dataset.price || 0) / 100,
    }));
    const groups = new Map();
    products.forEach((product) => {
      new Set(product.colors).forEach((color) => {
        if (!groups.has(color)) groups.set(color, []);
        groups.get(color).push(product);
      });
    });
    const paletteOrder = new Map(colorPalette.map((entry, index) => [entry.name, index]));
    const sortedGroups = [...groups.entries()].map(([name, groupProducts]) => ({ name, products: groupProducts })).sort((left, right) => {
      const leftOrder = paletteOrder.get(left.name) ?? 999;
      const rightOrder = paletteOrder.get(right.name) ?? 999;
      return leftOrder - rightOrder || left.name.localeCompare(right.name, 'ja');
    });
    const swatches = root.querySelector('[data-color-swatches]');
    const groupContainer = root.querySelector('[data-color-groups]');
    const formatter = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
    sortedGroups.forEach((group) => {
      swatches?.append(createColorSwatch(group));
      groupContainer?.append(createColorGroup(group, formatter));
    });
    const empty = root.querySelector('[data-color-empty]');
    if (empty) empty.hidden = sortedGroups.length > 0;
    const search = root.querySelector('[data-color-search]');
    if (search) search.hidden = sortedGroups.length === 0;
    root.querySelector('[data-color-source-list]')?.remove();
  };

  const initAllColorExplorers = () => document.querySelectorAll('[data-color-explorer]').forEach(initColorExplorer);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllColorExplorers, { once: true });
  } else {
    initAllColorExplorers();
  }
  document.addEventListener('shopify:section:load', initAllColorExplorers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-feature-explorer]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const splitValues = (value) => (value || '')
      .split(/\|\||[・、,／/]/)
      .map((item) => item.trim())
      .filter(Boolean);

    const unique = (values) => [...new Set(values.filter(Boolean))];
    const escapeHtml = (value) => String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
    const yen = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
    const shapePalette = ['#b9dcde', '#efd4c8', '#c9dfc7', '#edcbd4', '#c9ddea', '#d9cce7'];
    const shapePaths = {
      'オイスター': '<path class="shape-fill" d="M18 56C21 35 37 21 56 23C78 25 91 43 84 64C78 82 57 88 38 82C24 78 15 69 18 56Z"/><path class="shape-line" d="M27 62C42 57 57 47 70 35M31 72C48 65 66 54 79 43"/>',
      'オーバル': '<ellipse class="shape-fill" cx="50" cy="50" rx="30" ry="39"/><ellipse class="shape-line" cx="50" cy="50" rx="20" ry="28"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      'オクタゴン': '<path class="shape-fill" d="M34 16H66L84 34V66L66 84H34L16 66V34L34 16Z"/><path class="shape-line" d="M34 16L39 34H61L66 16M84 34L61 39V61L84 66M66 84L61 66H39L34 84M16 66L39 61V39L16 34"/>',
      'カービング': '<path class="shape-fill" d="M21 55C18 35 34 19 54 20C75 21 88 40 82 59C76 77 56 87 38 80C27 76 22 66 21 55Z"/><path class="shape-line" d="M32 59C30 44 43 32 57 35C69 38 73 53 65 62C57 71 41 67 42 55C43 47 52 44 58 49"/>',
      'キツネ': '<path class="shape-fill" d="M18 27L38 35C46 29 54 29 62 35L82 27L76 61C70 76 60 84 50 85C40 84 30 76 24 61L18 27Z"/><path class="shape-line" d="M32 51L43 55M68 51L57 55M43 68L50 73L57 68"/><circle cx="38" cy="54" r="2.5" fill="currentColor"/><circle cx="62" cy="54" r="2.5" fill="currentColor"/>',
      'キューブ': '<path class="shape-fill" d="M50 15L80 32L50 49L20 32L50 15Z"/><path class="shape-soft" d="M20 32L50 49V82L20 65V32Z"/><path class="shape-fill" d="M80 32L50 49V82L80 65V32Z"/><path class="shape-line" d="M50 49V82"/>',
      'ケシ': '<path class="shape-fill" d="M20 53C14 38 28 24 43 26C52 17 70 24 72 36C88 42 88 63 76 70C69 84 48 83 41 75C26 79 15 67 20 53Z"/><circle class="shape-hole" cx="51" cy="53" r="4"/>',
      'コイン': '<circle class="shape-fill" cx="50" cy="50" r="34"/><path class="shape-line" d="M20 57C36 69 66 71 80 56"/><circle class="shape-hole" cx="50" cy="47" r="4"/>',
      'さざれ': '<path class="shape-fill" d="M18 57L29 38L43 47L51 24L65 42L82 36L85 61L69 77L48 70L31 80L18 57Z"/><path class="shape-line" d="M29 38L48 70L65 42M43 47L69 77M51 24L82 36"/>',
      'スクエア': '<rect class="shape-fill" x="18" y="18" width="64" height="64" rx="7"/><rect class="shape-line" x="29" y="29" width="42" height="42" rx="3"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      'スター': '<path class="shape-fill" d="M50 13L60 38L87 40L66 57L73 84L50 69L27 84L34 57L13 40L40 38L50 13Z"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      'ソロバン': '<path class="shape-fill" d="M50 12L83 50L50 88L17 50L50 12Z"/><path class="shape-line" d="M17 50H83M50 12V88M28 50L50 34L72 50L50 66L28 50Z"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      'ダブルリング': '<circle class="shape-fill" cx="38" cy="50" r="25"/><circle class="shape-hole" cx="38" cy="50" r="12"/><circle class="shape-soft" cx="64" cy="50" r="25"/><circle class="shape-hole" cx="64" cy="50" r="12"/>',
      'ドロップ': '<path class="shape-fill" d="M50 12C42 32 23 49 23 67C23 83 35 91 50 91C65 91 77 83 77 67C77 49 58 32 50 12Z"/><path class="shape-line" d="M39 71C42 79 51 81 58 77"/><circle class="shape-hole" cx="50" cy="48" r="4"/>',
      'ハート': '<path class="shape-fill" d="M50 84L20 55C7 42 16 24 31 24C40 24 46 29 50 36C54 29 60 24 69 24C84 24 93 42 80 55L50 84Z"/><circle class="shape-hole" cx="50" cy="51" r="4"/>',
      'バラ': '<circle class="shape-soft" cx="50" cy="50" r="34"/><path class="shape-line" d="M50 76C33 73 24 59 29 45C34 31 50 25 63 32C77 39 80 56 70 67C61 77 45 73 41 62C37 51 46 41 56 43C65 45 67 57 60 62C54 66 47 62 47 56"/>',
      'バロック': '<path class="shape-fill" d="M23 35C31 20 48 20 59 28C74 25 85 39 80 52C88 66 75 82 61 78C50 89 31 81 31 68C17 61 14 46 23 35Z"/><circle class="shape-hole" cx="51" cy="52" r="4"/><circle cx="34" cy="39" r="3" fill="#fff" opacity=".7"/>',
      'フラット': '<ellipse class="shape-fill" cx="50" cy="51" rx="38" ry="20"/><path class="shape-line" d="M14 48C33 57 68 60 86 48"/><circle class="shape-hole" cx="50" cy="49" r="4"/>',
      'ブレスレット': '<circle class="shape-line" cx="50" cy="50" r="30" stroke-dasharray="3 5"/><circle class="shape-fill" cx="50" cy="18" r="7"/><circle class="shape-soft" cx="80" cy="50" r="7"/><circle class="shape-fill" cx="50" cy="82" r="7"/><circle class="shape-soft" cx="20" cy="50" r="7"/>',
      'ペア': '<path class="shape-fill" d="M50 13C43 31 24 48 24 67C24 83 36 91 50 91C64 91 76 83 76 67C76 48 57 31 50 13Z"/><path class="shape-line" d="M38 73C43 81 53 83 61 77"/><circle class="shape-hole" cx="50" cy="47" r="4"/>',
      'ボタン': '<ellipse class="shape-fill" cx="50" cy="50" rx="35" ry="25"/><ellipse class="shape-line" cx="50" cy="50" rx="26" ry="17"/><circle class="shape-hole" cx="43" cy="50" r="3"/><circle class="shape-hole" cx="57" cy="50" r="3"/>',
      'ポテト': '<path class="shape-fill" d="M27 26C41 14 64 18 76 31C87 44 82 65 70 77C57 89 36 85 25 74C13 62 15 38 27 26Z"/><circle class="shape-hole" cx="51" cy="51" r="4"/>',
      'ライス': '<path class="shape-fill" d="M18 50C29 31 39 22 50 22C61 22 71 31 82 50C71 69 61 78 50 78C39 78 29 69 18 50Z"/><path class="shape-line" d="M27 50C39 44 62 44 73 50"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      'ラウンド': '<circle class="shape-fill" cx="50" cy="50" r="34"/><circle class="shape-hole" cx="50" cy="50" r="4"/><path class="shape-line" d="M31 35C38 26 52 23 62 29"/>',
      'リボン': '<path class="shape-fill" d="M47 43C34 27 17 25 15 40C13 55 31 61 47 53V43ZM53 43C66 27 83 25 85 40C87 55 69 61 53 53V43Z"/><rect class="shape-soft" x="43" y="40" width="14" height="18" rx="4"/><path class="shape-line" d="M39 57L30 80L50 67L70 80L61 57"/>',
      'りんご': '<path class="shape-fill" d="M50 31C39 22 22 29 19 47C16 67 30 84 50 85C70 84 84 67 81 47C78 29 61 22 50 31Z"/><path class="shape-line" d="M50 31C50 20 57 14 66 13M54 20C62 20 69 24 73 30"/><circle class="shape-hole" cx="50" cy="52" r="4"/>',
      'レクタングル': '<rect class="shape-fill" x="16" y="27" width="68" height="46" rx="5"/><rect class="shape-line" x="27" y="36" width="46" height="28" rx="2"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      '花': '<g transform="translate(50 50)"><ellipse class="shape-fill" x="-13" y="-38" width="26" height="43" rx="13"/><ellipse class="shape-soft" x="-13" y="-38" width="26" height="43" rx="13" transform="rotate(72)"/><ellipse class="shape-fill" x="-13" y="-38" width="26" height="43" rx="13" transform="rotate(144)"/><ellipse class="shape-soft" x="-13" y="-38" width="26" height="43" rx="13" transform="rotate(216)"/><ellipse class="shape-fill" x="-13" y="-38" width="26" height="43" rx="13" transform="rotate(288)"/><circle class="shape-hole" r="10"/></g>',
      '花びら': '<path class="shape-fill" d="M50 14C65 30 77 46 76 61C75 78 63 87 50 87C37 87 25 78 24 61C23 46 35 30 50 14Z"/><path class="shape-line" d="M50 26V76M50 51C40 44 33 43 26 44M50 60C60 51 68 48 75 48"/>',
      '花火カット': '<circle class="shape-fill" cx="50" cy="50" r="35"/><path class="shape-line" d="M50 18V82M18 50H82M27 27L73 73M73 27L27 73M50 50L36 18M50 50L64 18M50 50L82 36M50 50L82 64M50 50L64 82M50 50L36 82M50 50L18 64M50 50L18 36"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      '桜': '<g transform="translate(50 51)"><path class="shape-fill" d="M0-9C-20-13-29-31-18-41C-8-50 3-39 0-24C5-41 19-47 27-35C35-22 21-12 8-9C24-11 36 2 29 14C22 27 7 20 1 8C7 24-2 39-16 34C-30 28-25 12-10 2C-27 11-43 3-41-11C-38-25-20-24 0-9Z"/><circle class="shape-hole" r="8"/></g>',
      '四つ葉': '<circle class="shape-fill" cx="37" cy="37" r="19"/><circle class="shape-soft" cx="63" cy="37" r="19"/><circle class="shape-soft" cx="37" cy="63" r="19"/><circle class="shape-fill" cx="63" cy="63" r="19"/><circle class="shape-hole" cx="50" cy="50" r="7"/>',
      '双子': '<circle class="shape-fill" cx="39" cy="50" r="28"/><circle class="shape-soft" cx="64" cy="50" r="28"/><circle class="shape-hole" cx="39" cy="50" r="4"/><circle class="shape-hole" cx="64" cy="50" r="4"/>',
      '多面ファセット': '<path class="shape-fill" d="M50 11L81 28L89 60L68 87H32L11 60L19 28L50 11Z"/><path class="shape-line" d="M50 11L39 35L19 28M50 11L61 35L81 28M11 60L39 35H61L89 60M32 87L39 35M68 87L61 35M11 60H89"/>',
      '猫': '<path class="shape-fill" d="M20 33L34 39C44 33 56 33 66 39L80 33L76 69C68 82 58 87 50 87C42 87 32 82 24 69L20 33Z"/><path class="shape-line" d="M34 56L42 59M66 56L58 59M43 70L50 74L57 70"/><circle cx="38" cy="58" r="2.5" fill="currentColor"/><circle cx="62" cy="58" r="2.5" fill="currentColor"/>',
      '菱形': '<path class="shape-fill" d="M50 10L88 50L50 90L12 50L50 10Z"/><path class="shape-line" d="M50 10L37 50L50 90M88 50H12M50 10L63 50L50 90"/><circle class="shape-hole" cx="50" cy="50" r="4"/>',
      '蕾': '<path class="shape-fill" d="M50 15C37 27 27 41 28 56C29 73 39 83 50 88C61 83 71 73 72 56C73 41 63 27 50 15Z"/><path class="shape-line" d="M50 24V82M50 61C39 52 33 44 30 35M50 61C61 52 67 44 70 35"/><path class="shape-soft" d="M28 65C18 62 14 53 16 43C27 43 36 49 39 59M72 65C82 62 86 53 84 43C73 43 64 49 61 59"/>'
    };
    const shapeIcon = (value, index) => {
      const accent = shapePalette[index % shapePalette.length];
      const drawing = shapePaths[value] || '<circle class="shape-fill" cx="50" cy="50" r="31"/><path class="shape-line" d="M30 50H70M50 30V70"/>';
      return `<span class="feature-explorer__option-media feature-explorer__option-media--shape" style="--shape-accent:${accent}"><svg class="feature-shape-icon" viewBox="0 0 100 100" role="img" aria-label="${escapeHtml(value)}の形状イラスト"><circle class="feature-shape-icon__plate" cx="50" cy="50" r="43"/>${drawing}<path class="feature-shape-icon__sparkle" d="M17 17V27M12 22H22M81 16V24M77 20H85"/></svg></span>`;
    };
    const products = [...root.querySelectorAll('[data-feature-source]')].map((node) => {
      const tags = splitValues(node.dataset.tags);
      const cuts = splitValues(node.dataset.cut);
      const features = [
        ...tags.filter((tag) => tag.startsWith('穴_')).map((tag) => tag.replace(/^穴_/, '')),
        ...tags.filter((tag) => tag.startsWith('グレード_')).map((tag) => `グレード ${tag.replace(/^グレード_/, '')}`),
        ...tags.filter((tag) => tag.startsWith('産地_')).map((tag) => `${tag.replace(/^産地_/, '')}産`)
      ];
      if (node.dataset.title.includes('大粒')) features.push('大粒');
      if (cuts.includes('斜め穴')) features.push('斜め穴');
      if (cuts.includes('コンケーブ')) features.push('コンケーブ');
      return {
        title: node.dataset.title,
        url: node.dataset.url,
        image: node.dataset.image || '',
        price: Number(node.dataset.price || 0),
        shape: unique(splitValues(node.dataset.shape)),
        cut: unique(cuts),
        feature: unique(features),
        size: unique(splitValues(node.dataset.size)),
        pack: unique(tags.filter((tag) => ['連売り', 'セット販売', '粒売り', '完成品'].includes(tag))),
        material: unique(splitValues(node.dataset.material))
      };
    });

    const sections = [
      { key: 'shape', eyebrow: 'SHAPE', title: '形状から探す' },
      { key: 'cut', eyebrow: 'CUT', title: 'カット・仕上げから探す' },
      { key: 'feature', eyebrow: 'FEATURE', title: '特徴から探す' },
      { key: 'pack', eyebrow: 'SALES FORMAT', title: '販売形態から探す' },
      { key: 'material', eyebrow: 'MATERIAL', title: '部材・商品タイプから探す' }
    ];

    const navigation = root.querySelector('[data-feature-navigation]');
    const subfilters = root.querySelector('[data-feature-subfilters]');
    const selectedShapeLabel = root.querySelector('[data-feature-selected-shape]');
    const sizeOptions = root.querySelector('[data-feature-size-options]');
    const productGrid = root.querySelector('[data-feature-products]');
    const resultHeading = root.querySelector('[data-feature-result-heading]');
    const resetButton = root.querySelector('[data-feature-reset]');
    const empty = root.querySelector('[data-feature-empty]');
    let selectedShape = '';

    const compareSizes = (a, b) => {
      const numberDifference = parseFloat(a) - parseFloat(b);
      return numberDifference || a.localeCompare(b, 'ja', { numeric: true });
    };

    const productCard = (product) => {
      const image = product.image
        ? `<div class="feature-explorer__product-media"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="560" height="560"></div>`
        : '<div class="feature-explorer__product-media"></div>';
      return `<a class="feature-explorer__product" href="${escapeHtml(product.url)}">${image}<p class="feature-explorer__product-title">${escapeHtml(product.title)}</p><p class="feature-explorer__product-price">${yen.format(product.price / 100)}</p></a>`;
    };

    const renderProducts = (filteredProducts, label) => {
      productGrid.innerHTML = filteredProducts.map(productCard).join('');
      resultHeading.textContent = `${label}（${filteredProducts.length}件）`;
      empty.hidden = filteredProducts.length > 0;
      productGrid.hidden = filteredProducts.length === 0;
    };

    const hideSizeSubfilters = () => {
      selectedShape = '';
      selectedShapeLabel.textContent = '';
      sizeOptions.innerHTML = '';
      subfilters.hidden = true;
    };

    const renderSizeSubfilters = (shape) => {
      selectedShape = shape;
      const shapeProducts = products.filter((product) => product.shape.includes(shape));
      const sizes = unique(shapeProducts.flatMap((product) => product.size)).sort(compareSizes);
      if (!sizes.length) {
        hideSizeSubfilters();
        return false;
      }

      selectedShapeLabel.textContent = shape;
      const allOption = `<button class="feature-explorer__size-option" type="button" data-feature-size-value="" aria-pressed="true">すべて <small>(${shapeProducts.length})</small></button>`;
      const options = sizes.map((size) => {
        const count = shapeProducts.filter((product) => product.size.includes(size)).length;
        return `<button class="feature-explorer__size-option" type="button" data-feature-size-value="${escapeHtml(size)}" aria-pressed="false">${escapeHtml(size)} <small>(${count})</small></button>`;
      }).join('');
      sizeOptions.innerHTML = allOption + options;
      subfilters.hidden = false;
      return true;
    };

    sections.forEach((section) => {
      const values = unique(products.flatMap((product) => product[section.key])).sort((a, b) => a.localeCompare(b, 'ja'));
      if (!values.length) return;
      const wrapper = document.createElement('section');
      wrapper.className = 'feature-explorer__category';
      const options = values.map((value, index) => {
        const matches = products.filter((product) => product[section.key].includes(value));
        const representative = matches.find((product) => product.image) || matches[0];
        const media = section.key === 'shape'
          ? shapeIcon(value, index)
          : representative && representative.image
            ? `<span class="feature-explorer__option-media"><img src="${escapeHtml(representative.image)}" alt="" loading="lazy" width="128" height="128"></span>`
            : '<span class="feature-explorer__option-media"></span>';
        return `<button class="feature-explorer__option" type="button" data-feature-kind="${escapeHtml(section.key)}" data-feature-value="${escapeHtml(value)}" aria-pressed="false">${media}<span><span class="feature-explorer__option-name">${escapeHtml(value)}</span><span class="feature-explorer__option-count">${matches.length}商品</span></span></button>`;
      }).join('');
      wrapper.innerHTML = `<div class="feature-explorer__category-heading"><p>${section.eyebrow}</p><h2>${section.title}</h2></div><div class="feature-explorer__options">${options}</div>`;
      navigation.appendChild(wrapper);
    });

    navigation.addEventListener('click', (event) => {
      const button = event.target.closest('[data-feature-kind]');
      if (!button) return;
      root.querySelectorAll('[data-feature-kind]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      const kind = button.dataset.featureKind;
      const value = button.dataset.featureValue;
      renderProducts(products.filter((product) => product[kind].includes(value)), `「${value}」の商品`);
      resetButton.hidden = false;
      if (kind === 'shape' && renderSizeSubfilters(value)) {
        subfilters.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        hideSizeSubfilters();
        root.querySelector('.feature-explorer__results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    sizeOptions.addEventListener('click', (event) => {
      const button = event.target.closest('[data-feature-size-value]');
      if (!button || !selectedShape) return;
      sizeOptions.querySelectorAll('[data-feature-size-value]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      const size = button.dataset.featureSizeValue;
      const filteredProducts = products.filter((product) => product.shape.includes(selectedShape) && (!size || product.size.includes(size)));
      const label = size ? `「${selectedShape}・${size}」の商品` : `「${selectedShape}」の商品`;
      renderProducts(filteredProducts, label);
      root.querySelector('.feature-explorer__results').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    resetButton.addEventListener('click', () => {
      root.querySelectorAll('[data-feature-kind]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      hideSizeSubfilters();
      renderProducts(products, 'すべての商品');
      resetButton.hidden = true;
    });

    renderProducts(products, 'すべての商品');
  })();

  } catch(e) { console.error(e); }
})();
})();
